import React, { createContext, useContext, useState } from "react";

// Create the context
const AssessmentSaveAndExitContext = createContext();

// Create a provider component
export const AssessmentSaveAndExitProvider = ({ children }) => {
  const [showSaveAndExitModal, setShowSaveAndExitModal] = useState(false);

  const toggleSaveAndExitModal = () => {
    setShowSaveAndExitModal(!showSaveAndExitModal);
  };

  return (
    <AssessmentSaveAndExitContext.Provider
      value={{ showSaveAndExitModal, toggleSaveAndExitModal }}
    >
      {children}
    </AssessmentSaveAndExitContext.Provider>
  );
};

export const useAssessmentSaveAndExit = () =>
  useContext(AssessmentSaveAndExitContext);
